export const AiSvg = (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M5.37492 3.7182C5.61947 3.7182 5.8366 3.87486 5.91393 4.10712L6.74738 6.61014L9.24771 7.44449C9.47972 7.5219 9.63621 7.73926 9.63621 7.98408C9.63621 8.2289 9.47972 8.44626 9.24771 8.52368L6.74738 9.35802L5.91393 11.861C5.8366 12.0933 5.61947 12.25 5.37492 12.25C5.13036 12.25 4.91324 12.0933 4.8359 11.861L4.00245 9.35802L1.50212 8.52368C1.27011 8.44626 1.11362 8.2289 1.11362 7.98408C1.11362 7.73926 1.27011 7.5219 1.50212 7.44449L4.00245 6.61014L4.8359 4.10712C4.91324 3.87486 5.13036 3.7182 5.37492 3.7182Z"
      fill="#F5B700"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M9.9203 1.11377C10.067 1.11377 10.1973 1.20777 10.2437 1.34712L10.687 2.6783L12.0167 3.12203C12.1559 3.16848 12.2498 3.29889 12.2498 3.44578C12.2498 3.59268 12.1559 3.72309 12.0167 3.76954L10.687 4.21327L10.2437 5.54445C10.1973 5.6838 10.067 5.7778 9.9203 5.7778C9.77357 5.7778 9.64329 5.6838 9.59689 5.54445L9.15364 4.21327L7.82389 3.76954C7.68469 3.72309 7.59079 3.59268 7.59079 3.44578C7.59079 3.29889 7.68469 3.16848 7.82389 3.12203L9.15364 2.6783L9.59689 1.34712C9.64329 1.20777 9.77357 1.11377 9.9203 1.11377Z"
      fill="#F5B700"
      fill-rule="evenodd"
    />
  </svg>
);
